var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"capitalHeader"},[_c('div',{staticClass:"capitalHeaderBox"},[_c('el-row',[_c('el-col',{attrs:{"span":5}},[_c('div',{staticClass:"logo",on:{"click":function($event){return _vm.goIndex()}}},[_c('img',{attrs:{"src":_vm.logoUrlGetter}})])])],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }